import * as React from "react";

import Button from "@material-ui/core/Button";
import { DetailActionProps, getNextPage } from "../detail-actions-props";
import EditIcon from "@material-ui/icons/Edit";
import { requestEdit as requestEditRelease } from "../../../../../sdk/release";
import LoadingIcon from "@material-ui/icons/Timelapse";
import { MessageDialog } from "../message-dialog/index";
import { useHistory, useLocation } from "react-router";
import { handleReleaseEditRequested } from "../../../../../utils/rudderstack/events";

export const EditReleaseCtrl: React.FC<DetailActionProps> = (props) => {
  const { data } = props;
  const history = useHistory();
  const location = useLocation<{from?: string}>();

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleReject = async (message: string) => {
    setLoading(true);
    setOpen(false);
    await Promise.all(
      data.map(async ({ release, assets, tracks }) => {
        await requestEditRelease(
          release.id,
          release.UPCEAN as string,
          `${release.id}.json`,
          !!assets?.some((a) => a.category === "video"),
          release.cover.url,
          release.title,
          message
        );
        await handleReleaseEditRequested({release, tracks})
      })
    );
    setLoading(false);

    props.onAction(data.map(({ release }) => release.id));

    history.push(getNextPage(location.state?.from), location.state);
  };

  return (
    <>
      <Button
        variant="contained"
        color="default"
        endIcon={loading ? <LoadingIcon /> : <EditIcon />}
        onClick={() => setOpen(true)}
      >
        Request Edit
      </Button>

      <MessageDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        onSend={handleReject}
        title={`Request edit: ${
          data.length === 1 ? data[0].release.title : `${data.length} releases`
        }`}
        default={props.default}
      />
    </>
  );
};
